import { useLocalizePath, useT } from '../../../helpers/i18n';

// Same notice as the Lodge footer (theme_1 footer.html.twig): only when the site has a privacy policy and/or terms of use.
// The sentence is translated as a whole ({privacy} / {terms} mark where the links go) because word order and articles
// differ per language.
export default function PolicyNotice ( props : { hasPrivacyPolicy?: boolean, hasTermsAndConditions?: boolean } ) {
  const localizePath = useLocalizePath();
  const t = useT();

  if ( !props.hasPrivacyPolicy && !props.hasTermsAndConditions ) {
    return null;
  }

  const linkStyle = { color: 'inherit', textDecoration: 'underline' };
  const links = {
    '{privacy}': <a href={localizePath( '/privacy-policy' )} target="_self" style={linkStyle}>{t('footer.privacyPolicy')}</a>,
    '{terms}': <a href={localizePath( '/terms-and-conditions' )} target="_self" style={linkStyle}>{t('footer.termsOfUse')}</a>,
  };

  const key = props.hasPrivacyPolicy && props.hasTermsAndConditions ? 'footer.policyNoticeBoth'
      : props.hasPrivacyPolicy ? 'footer.policyNoticePrivacy' : 'footer.policyNoticeTerms';

  return (
    <p className="fs-11 muted">
      {t(key).split( /(\{privacy\}|\{terms\})/ ).map( ( part, i ) => <span key={i}>{links[part] ?? part}</span> )}
    </p>
  );
}
